import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import { AppProviders } from './AppProviders';
import { AppRouter } from './AppRouter';

const App = () => {
  return (
    <BrowserRouter>
      <AppProviders>
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
      </AppProviders>
    </BrowserRouter>
  );
};

export default App;
